import { render, staticRenderFns } from "./CloseSvg.vue?vue&type=template&id=b2efa6bc&scoped=true"
import script from "./CloseSvg.vue?vue&type=script&lang=js"
export * from "./CloseSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2efa6bc",
  null
  
)

export default component.exports